import { render, staticRenderFns } from "./UnavailableReason.vue?vue&type=template&id=2122e2b8&scoped=true&"
import script from "./UnavailableReason.vue?vue&type=script&lang=js&"
export * from "./UnavailableReason.vue?vue&type=script&lang=js&"
import style0 from "./UnavailableReason.vue?vue&type=style&index=0&id=2122e2b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2122e2b8",
  null
  
)

export default component.exports